/**
 * REAL GAP FOUND AND FIXED: several dashboard mutations (`orders.refund` among them -
 * packages/rbac's `REAUTH_REQUIRED_PERMISSIONS`) require a short-lived re-auth token
 * (`X-Reauth-Token`, from `POST /dashboard/auth/reauth`) regardless of session age - this app had
 * no code anywhere that ever obtained or sent one, so every such action failed with a 403
 * ("requires a fresh re-authentication") and there was no way to recover from it through the UI.
 *
 * In-memory only, never persisted (sessionStorage/localStorage) - the server's own token is
 * already short-lived (5 minutes, apps/api/src/routes/dashboard/auth.ts's `REAUTH_TTL_SECONDS`),
 * so nothing is gained by surviving a reload, and keeping it out of storage is one less place a
 * sensitive token could linger.
 */
let reauthToken: string | undefined;

export function getReauthToken(): string | undefined {
  return reauthToken;
}

export function setReauthToken(token: string): void {
  reauthToken = token;
}

export function clearReauthToken(): void {
  reauthToken = undefined;
}
